import React, { useState, useEffect, Fragment, useContext } from 'react';
import { Stack, TableRow, Button, TextField, Typography } from '@mui/material';
import { DatePicker } from '@mui/lab';
import { backendFetch, backendPutWithJson, backendPostWithJson } from '../../backend/backend';
import Subtitle from '../ui/Subtitle';
import { DateTime } from 'luxon';
import { tokenContext } from '../TokenProvider';
import { TSCell, TSTable } from '../ui/TableStructure';

import { useIsMediumDown } from '../../utils/responsive';

const SeasonsPage = () => {
    const isMediumDown=useIsMediumDown();
    const [seasons,setSeasons]=useState();
    const [activeSeason,setActiveSeason]=useState(null);
    const [futureSeason,setFutureSeason]=useState(null);
    const [update,setUpdate]=useState(false);
    const [newSeasonStartDate,setNewSeasonStartDate]=useState();
    const [newSeasonEndDate,setNewSeasonEndDate]=useState();
    const [activeSeasonStartDate,setActiveSeasonStartDate]=useState();
    const [activeSeasonEndDate,setActiveSeasonEndDate]=useState();
    const [activeSeasonMaxScores,setActiveSeasonMaxScores]=useState();
    const [activeSeasonChanged,setActiveSeasonChanged]=useState(false);
    const [fetched,setFetched]=useState(false);
    const {token,dropAdmin}=useContext(tokenContext);

    const forceUpdate = () => { setUpdate((update) => !update); }

    const closeSeason = async (season) => {
        await backendPutWithJson(token,dropAdmin,`seasons/${season.startDate}`,{
            startDate:season.startDate,
            endDate:season.endDate,
            status:"past",
            maxScoresToCount:season.maxScoresToCount
        });
        setActiveSeason(null);
        forceUpdate();
    }

    const activateSeason = async (season) => {
        await backendPutWithJson(token,dropAdmin,`seasons/${season.startDate}`,{
            startDate:season.startDate,
            endDate:season.endDate,
            status:"active",
            maxScoresToCount:season.maxScoresToCount
        });
        setFutureSeason(null);
        forceUpdate();
    }

    const updateActiveSeason = async (season) => {
        await backendPutWithJson(token,dropAdmin,`seasons/${season.startDate}`,{
            startDate:activeSeasonStartDate,
            endDate:activeSeasonEndDate,
            status:season.status,
            maxScoresToCount:activeSeasonMaxScores
        });
        setActiveSeasonChanged(false);
        //forceUpdate();
    }

    const createSeason = async () => {
        await backendPostWithJson(token,dropAdmin,`seasons/${newSeasonStartDate}`,{
            endDate:newSeasonEndDate
        });
        forceUpdate();
    }

    useEffect(()=> {
        async function fetchData() {
            setFetched(false);
            const seasons=await backendFetch('seasons');
            var latestSeasonStartYear=2007;
            seasons.forEach((season) => {
                if (season.status==="active") {
                    setActiveSeasonStartDate(season.startDate);
                    setActiveSeasonEndDate(season.endDate);
                    setActiveSeasonMaxScores(season.maxScoresToCount);
                    setActiveSeason(season);
                }
                else if (season.status==="future") {
                    setFutureSeason(season);
                }
                var year=DateTime.fromISO(season.startDate).year;
                if (year>latestSeasonStartYear)
                    latestSeasonStartYear=year;
            });
            setNewSeasonStartDate(DateTime.fromISO(`${latestSeasonStartYear+1}-09-01`).toISODate());
            setNewSeasonEndDate(DateTime.fromISO(`${latestSeasonStartYear+2}-06-30`).toISODate());
            setSeasons(seasons);
            setFetched(true);
        }
        fetchData()
    },[update]);
    const renderDatePickerInput=(p)=><TextField sx={{width:160}} {...p}/>

        if (isMediumDown) {
            return(
                <Stack maxWidth={480}>
                    <Subtitle text="Seasons"/>
                    {fetched &&
                    <Fragment>
                        {activeSeason?
                            <Stack spacing={0}>
                                <TSTable title="Active" headings={["Start Date","End Date"]}>
                                    <TableRow>
                                        <TSCell>
                                            <DatePicker
                                                value={activeSeasonStartDate}
                                                onChange={(newValue)=>{setActiveSeasonStartDate(newValue.toISODate());setActiveSeasonChanged(true);}}
                                                inputFormat="yyyy-MM-dd"
                                                renderInput={renderDatePickerInput}
                                            />
                                        </TSCell>
                                        <TSCell>
                                            <DatePicker
                                                value={activeSeasonEndDate}
                                                onChange={(newValue)=>{setActiveSeasonEndDate(newValue.toISODate());setActiveSeasonChanged(true);}}
                                                inputFormat="yyyy-MM-dd"
                                                renderInput={renderDatePickerInput}
                                            />
                                        </TSCell>
                                    </TableRow>
                                </TSTable>
                                <TSTable headings={["Max Games","Actions"]}>
                                    <TableRow>
                                        <TSCell sx={{width:"50%"}}>
                                            <TextField value={activeSeasonMaxScores} onChange={(e)=>{setActiveSeasonMaxScores(e.target.value);setActiveSeasonChanged(true);}}/>
                                        </TSCell>
                                        <TSCell>
                                            {
                                                activeSeasonChanged?
                                                    <Button variant="contained" onClick={() => updateActiveSeason(activeSeason)}>Update</Button>
                                                    :
                                                    <Button variant="contained" onClick={() => closeSeason(activeSeason)}>Close</Button>
                                            }
                                        </TSCell>
                                    </TableRow>
                                </TSTable>
                            </Stack>
                            :
                            <Fragment>
                                <Typography variant="h4">No active season</Typography>
                                {futureSeason &&
                                <TSTable title="Future" headings={["Start Date","End Date"]}>
                                    <TableRow>
                                        <TSCell>{futureSeason.startDate}</TSCell>
                                        <TSCell>{futureSeason.endDate}</TSCell>
                                    </TableRow>
                                    <TableRow>
                                        <TSCell></TSCell>
                                        <TSCell>
                                            <Button variant="contained" onClick={() => activateSeason(futureSeason)}>Activate</Button>
                                        </TSCell>
                                    </TableRow>
                                </TSTable>
                                }
                            </Fragment>
                        }
                        <TSTable title="New" headings={["Start Date","End Date"]}>
                            <TableRow>
                                <TSCell>
                                    <DatePicker
                                        value={newSeasonStartDate}
                                        onChange={(newValue)=>{setNewSeasonStartDate(newValue.toISODate())}}
                                        inputFormat="yyyy-MM-dd"
                                        renderInput={renderDatePickerInput}
                                    />
                                </TSCell>
                                <TSCell>
                                    <DatePicker
                                        value={newSeasonEndDate}
                                        onChange={(newValue)=>{setNewSeasonEndDate(newValue.toISODate())}}
                                        inputFormat="yyyy-MM-dd"
                                        renderInput={renderDatePickerInput}
                                    />
                                </TSCell>
                            </TableRow>
                            <TableRow>
                                <TSCell></TSCell>
                                <TSCell><Button variant="contained" onClick={() => createSeason()}>Create</Button></TSCell>
                            </TableRow>
                        </TSTable>
                    </Fragment>
                    }
                </Stack>
            );
        }
    else {
        const renderActiveSeason = (season) => {
            return(<Fragment>
                <TSCell>
                    <DatePicker
                        value={activeSeasonStartDate}
                        onChange={(newValue)=>{setActiveSeasonStartDate(newValue.toISODate());setActiveSeasonChanged(true);}}
                        inputFormat="yyyy-MM-dd"
                        renderInput={renderDatePickerInput}
                    />
                </TSCell>
                <TSCell>
                    <DatePicker
                        value={activeSeasonEndDate}
                        onChange={(newValue)=>{setActiveSeasonEndDate(newValue.toISODate());setActiveSeasonChanged(true);}}
                        inputFormat="yyyy-MM-dd"
                        renderInput={renderDatePickerInput}
                    />
                </TSCell>
                <TSCell>
                    <TextField sx={{width:80}} value={activeSeasonMaxScores} onChange={(e)=>{setActiveSeasonMaxScores(e.target.value);setActiveSeasonChanged(true);}}/>
                </TSCell>
                <TSCell>{season.statusDescription}</TSCell>
                <TSCell>
                    <Stack direction="row">
                        <Button variant="contained" onClick={() => closeSeason(season)}>Close</Button>
                        <Button variant="contained" onClick={() => updateActiveSeason(season)} disabled={!activeSeasonChanged}>Update</Button>
                    </Stack>
                </TSCell>
            </Fragment>);
        }

        const renderSeasons = () => {
            if (seasons===undefined)
                return <Fragment/>;
            return seasons.map((season,i) =>
                <TableRow key={i+season}>
                    {
                        ((season.status==="active") && renderActiveSeason(season))
                            ||	<Fragment>
                                <TSCell sx={{paddingLeft:2}}>{season.startDate}</TSCell>
                                <TSCell sx={{paddingLeft:2}}>{season.endDate}</TSCell>
                                <TSCell sx={{paddingLeft:2}}>{season.maxScoresToCount}</TSCell>
                                <TSCell>{season.statusDescription}</TSCell>
                                <TSCell>
                                    <Stack direction="row">
                                        {season.status==="future" && <Button variant="contained" onClick={() => activateSeason(season)} disabled={activeSeason}>Activate</Button>}
                                    </Stack>
                                </TSCell>
                            </Fragment>
                    }
                </TableRow>
            );
        }

        return(
            <Stack spacing="0">
                <Subtitle text="Seasons"/>
                { fetched &&
                <TSTable headings={["Start Date","End Date","Max Games Count","Status","Actions"]} style={{width:"750px"}}>
                    <TableRow>
                        <TSCell>
                            <DatePicker
                                value={newSeasonStartDate}
                                onChange={(newValue)=>{setNewSeasonStartDate(newValue.toISODate())}}
                                inputFormat="yyyy-MM-dd"
                                renderInput={renderDatePickerInput}
                            />
                        </TSCell>
                        <TSCell>
                            <DatePicker
                                value={newSeasonEndDate}
                                onChange={(newValue)=>{setNewSeasonEndDate(newValue.toISODate())}}
                                inputFormat="yyyy-MM-dd"
                                renderInput={renderDatePickerInput}
                            />
                        </TSCell>
                        <TSCell sx={{width:100}}></TSCell>
                        <TSCell></TSCell>
                        <TSCell><Button variant="contained" onClick={() => createSeason()}>Create</Button></TSCell>
                    </TableRow>
                    {renderSeasons()}
                </TSTable>
                }
            </Stack>
        );
    }
};

export default SeasonsPage;
